import { useEffect } from 'react';
import { UserGroupIcon } from '@heroicons/react/outline';
import { useSetAtom, useAtom } from 'jotai';
import { notificationAtom, pageLoadingAtom } from '../../atoms/system';
import { listLoadCustomerAtom, detailCustomerAtom } from '../../atoms/customer';
import api from '../../api';
import _ from 'lodash';
import cuid from 'cuid';
import { IResponse } from '../../types';
import { Header } from '../../widgets';
import ReactPaginate from 'react-paginate';
import { useImmer } from 'use-immer';
import queryString from 'query-string';
import { LISTURL } from '../../config';
import { ICustomer } from '../../inter/list';
import { ListCustomerPayload } from '../../schema';
import ItemCustomer from './Item.Customer';
import DetailCustomer from './Detail.Customer';
import produce from 'immer';

const breadcrumbs = [
  { name: 'Khách hàng', href: LISTURL.question_list, current: false },
  { name: 'Danh sách', href: LISTURL.question_list, current: true },
];

const List = (): JSX.Element => {
  const notification = useSetAtom(notificationAtom);
  const pageLoading = useSetAtom(pageLoadingAtom);
  const [listLoad, setListLoad] = useAtom(listLoadCustomerAtom);
  const [listData, setListData] = useImmer<ICustomer>({
    limit: 50,
    list: [],
    page: 1,
    total: -1,
  });
  const [queryOptions, setQueryOptions] = useImmer<ListCustomerPayload>({
    page: listData.page,
    limit: listData.limit,
  });

  useEffect(() => {
    (async () => {
      try {
        pageLoading(true);
        const query = queryString.stringify(queryOptions, {
          skipNull: true,
          skipEmptyString: true,
        });
        const result = await api
          .get(`api/customers?${query}`)
          .json<IResponse<ICustomer>>();
        setListData(result.data);
      } catch (e) {
        console.log(e);
        notification({
          show: true,
          type: null,
          title: null,
        });
      } finally {
        pageLoading(false);
      }
    })();
  }, [listLoad]);
  const setShowDetailCustomer = useSetAtom(detailCustomerAtom);
  const handleAction = (
    id: string,
    info: {
      name: string;
      email: string;
    },
  ) => {
    setShowDetailCustomer(
      produce(draft => {
        draft.show = true;
        draft.customer_id = id;
        draft.info = info;
      }),
    );
  };

  return (
    <>
      <div className="flex flex-col">
        <Header
          title="Danh sách khách hàng đánh giá"
          breadcrumbs={breadcrumbs}
          action={null}
        />
        <div className="p-3 mt-3">
          <div className="flex flex-col space-y-4">
            {listData.total < 0 ? null : listData.total > 0 ? (
              <div className="flex flex-col space-y-2">
                <div className="overflow-x-auto whitespace-nowrap">
                  <div className="min-w-[1050px] flex justify-between text-left text-xs font-medium text-gray-500 uppercase tracking-wide">
                    <div className="px-0 py-4 text-left w-[350px]">
                      Tên khách hàng
                    </div>
                    <div className="w-[350px] px-2 py-4">Email</div>
                    <div className="w-[200px] px-2 py-4">Số điện thoại</div>
                    <div className="min-w-[150x] flex-1 px-2 py-4">
                      Số lượng tương tác
                    </div>
                  </div>
                  <div className="min-w-[1050px] flex flex-col space-y-3 whitespace-normal">
                    {listData.list.map((item, key: number) => (
                      <ItemCustomer
                        props={item}
                        action={handleAction}
                        key={key}
                      />
                    ))}
                  </div>
                </div>
                <div className="flex justify-between items-center flex-col-reverse lg:flex-row">
                  <div className="flex-1 basis-1/6 justify-start text-xs text-gray-500 hidden lg:flex"></div>
                  <div className="flex flex-1 basis-4/6 justify-center">
                    <ReactPaginate
                      pageCount={_.ceil(listData.total / listData.limit)}
                      containerClassName="flex justify-center space-x-2 mt-2"
                      pageLinkClassName="bg-white text-gray-500 hover:bg-gray-50 w-8 h-8 inline-flex justify-center items-center text-xs shadow-xs rounded-full"
                      activeLinkClassName="!bg-indigo-600 !text-gray-50 pointer-events-none"
                      breakLinkClassName="pointer-events-none bg-white text-gray-500 hover:bg-gray-50 w-8 h-8 inline-flex justify-center items-center text-xs shadow-xs rounded-full"
                      nextClassName="hidden"
                      previousClassName="hidden"
                      forcePage={listData.page - 1}
                      onPageChange={page => {
                        setQueryOptions(draft => {
                          draft.page = page.selected + 1;
                        });
                        setListLoad(cuid());
                      }}
                    />
                  </div>
                  <div className="flex flex-1 basis-1/6 justify-end text-xs text-gray-500">
                    Tổng {listData.total} câu hỏi
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex flex-col py-12">
                <div className="text-center">
                  <UserGroupIcon className="mx-auto h-12 w-12 text-gray-400" />
                  <h3 className="mt-2 text-md font-medium text-gray-900">
                    Chưa có khách hàng nào
                  </h3>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <DetailCustomer />
    </>
  );
};

export default List;
